module.exports = __webpack_public_path__ + "img/5_26@2x.29d90542.png";